import { Link } from "react-router-dom";
import {
    // FeedPostDropDown,
    IncidentLocation,
    MediaType,
    PostText,
    PostUserBlock,
    SocialCount
} from "ui";
import { FeedIncidentObj } from "utils/types/general.types";

export type FeedIncidentProps = {
    incident: FeedIncidentObj;
    showLink?: boolean;
};

const FeedIncident = ({ incident, showLink = true }: FeedIncidentProps) => {
    return (
        <div className="card is-post relative">
            {/* <!-- Main wrap --> */}
            {showLink && (
                <Link
                    to={`/incidents/view/${incident.id}`}
                    className="absolute float-link"
                ></Link>
            )}

            <div className={`content-wrap`}>
                {/* <!-- Post header --> */}
                <div className="card-heading">
                    {/* <!-- User meta --> */}
                    <PostUserBlock user={incident.user} time={incident.time} />
                    {/* Right side dropdown */}
                    {/* <FeedPostDropDown /> */}
                </div>
                {/* <!-- /Post header --> */}

                {/* <!-- Post body --> */}

                <div className="card-body">
                    <IncidentLocation location={incident.location} />
                    {/* <!-- Post body text --> */}
                    <PostText text={incident.text} />
                    {/* <!-- Featured image --> */}
                    <div>
                        <MediaType mediaType={incident.mediaType} />
                    </div>
                </div>
                {/* <!-- /Post body --> */}

                {/* <!-- Post footer --> */}
                <div className="card-footer">
                    {/* <!-- Post statistics --> */}
                    <SocialCount
                        counts={incident.socialCount}
                        postId={incident.id}
                    />
                </div>
                {/* <!-- /Post footer --> */}
            </div>
            {/* <!-- /Main wrap --> */}
        </div>
    );
};

export default FeedIncident;
